import { t } from "@connect/i18n";

interface CardNumberErrorArgs {
  /** The issuing BIN is on the disallow-list; takes precedence over every other check. */
  binBlocked: boolean;
  /** Issuing card type from the BIN lookup, or null until it resolves. */
  cardPaymentType: "credit" | "debit" | null;
  /** ISO alpha-3 issuing country from the BIN lookup, or null when unknown. */
  cardIssuingCountry: string | null;
  /** ISO alpha-3 billing-address country; used when the BIN lookup reports no country. */
  billingCountry: string | null | undefined;
}

// Message shown under the card-number field as soon as the BIN is known, or null
// when the card is acceptable. A disallowed BIN wins over the US-credit block.
// The country is the card's issuing country when known, otherwise the billing
// address country — so changing the billing country to the US re-triggers it.
export function resolveCardNumberError({
  binBlocked,
  cardPaymentType,
  cardIssuingCountry,
  billingCountry,
}: CardNumberErrorArgs): string | null {
  if (binBlocked) {
    return t("addCard.errors.cardNotSupported");
  }
  const country = cardIssuingCountry ?? billingCountry ?? null;
  if (cardPaymentType === "credit" && country?.toUpperCase() === "USA") {
    return t("addCard.errors.usCreditNotSupported");
  }
  return null;
}
